import InnerComponent from '@Components/Purchase/DebitNotes/ViewDebitNote';
import orgContainer from '@Components/AppContainer';

const ViewDebitNotePage = () => ((orgContainer(InnerComponent)));
export default ViewDebitNotePage;
